import React from 'react';
import { siteData } from '../mock';
import { Button } from './ui/button';

const ServiceCard = ({ svc }) => (
  <div className="relative overflow-hidden rounded-md group cursor-pointer aspect-[16/10]">
    <img
      src={svc.image}
      alt={svc.title}
      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
    />
  </div>
);

const ServiceTimes = ({ onPlanVisit }) => {
  const { services, address, planVisit } = siteData;
  return (
    <section className="bg-[#232323] text-white py-24 md:py-32 px-6 md:px-12">
      <div className="max-w-[1300px] mx-auto">
        <h2
          className="text-center text-[44px] md:text-[62px] lg:text-[74px] leading-none mb-16 md:mb-20"
          style={{ fontFamily: 'Fraunces, serif', fontWeight: 500 }}
        >
          Service Times
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {services.map((s) => (
            <ServiceCard key={s.id} svc={s} />
          ))}
        </div>

        <div className="mt-24 md:mt-32 text-center">
          <h3
            className="text-[32px] md:text-[46px] lg:text-[54px] leading-tight"
            style={{ fontFamily: 'Fraunces, serif', fontWeight: 500 }}
          >
            {address}
          </h3>
        </div>

        <div className="mt-24 md:mt-28 text-center max-w-[720px] mx-auto">
          <h3
            className="text-[40px] md:text-[56px] lg:text-[64px] mb-6"
            style={{ fontFamily: 'Fraunces, serif', fontWeight: 500 }}
          >
            {planVisit.title}
          </h3>
          <p className="text-white/85 text-[17px] md:text-[18px] max-w-[520px] mx-auto leading-relaxed">
            {planVisit.text}
          </p>
          <Button
            onClick={onPlanVisit}
            className="mt-10 rounded-full bg-[#e9e3d7] hover:bg-white text-[#1a1a1a] px-9 py-6 h-auto text-[15px] font-medium"
          >
            {planVisit.cta}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServiceTimes;
